import { Component, type ReactNode } from 'react';
import { etoUstarevshiyKusok, perezagruzitOdinRaz } from './ustarevshiyKusok';

/**
 * ⛔ s523 — ВКЛАДКА, ОТКРЫТАЯ ЧЕРЕЗ ВЫКАТ, БОЛЬШЕ НЕ БЕЛЕЕТ.
 *
 * Граница над маршрутами ловит отказ ленивого импорта во время перехода:
 * страница просит кусок сборки со старым хэшем, которого после выката на диске
 * уже нет. Перезагрузка ОДНА — новая сборка подтянет правильные имена.
 *
 * ⛔ Любая другая ошибка пробрасывается дальше: граница не должна прятать
 * настоящие дефекты. Распознаватель и защита от петли живут в
 * `ustarevshiyKusok.ts` — там же их проверяет ловушка.
 */
interface Props {
  children: ReactNode;
}

interface State {
  sdalis: boolean;
}

export class UstarevshiyKusok extends Component<Props, State> {
  state: State = { sdalis: false };

  static getDerivedStateFromError(oshibka: unknown): State | null {
    if (!etoUstarevshiyKusok(oshibka)) {
      throw oshibka;
    }

    return { sdalis: !perezagruzitOdinRaz() };
  }

  render(): ReactNode {
    if (this.state.sdalis) {
      return (
        <div style={{ padding: 24, fontSize: 14, lineHeight: 1.5 }}>
          <p style={{ marginBottom: 12 }}>
            Панель обновилась, а эта вкладка осталась на старой версии — и новая часть не загрузилась.
          </p>
          <button type="button" onClick={() => window.location.reload()}>
            Обновить страницу
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
